import { supabase } from "@/integrations/supabase/client";

/**
 * Cancel any pending (delayed) email dispatch for this user + conversation + event.
 * Used when the user opens a chat or returns a missed call — prevents redundant emails.
 */
export async function cancelPendingDispatch(opts: {
  userId: string;
  conversationId?: string | null;
  eventType?: string;
}) {
  const { userId, conversationId, eventType = "missed_call" } = opts;
  if (!userId) return;
  try {
    let q = supabase
      .from("pending_email_dispatches" as any)
      .update({ cancelled: true, cancelled_at: new Date().toISOString() } as any)
      .eq("user_id", userId)
      .eq("event_type", eventType)
      .eq("cancelled", false)
      .eq("sent", false);
    if (conversationId) q = q.eq("conversation_id", conversationId);
    await q;
  } catch (e) {
    console.warn("[cancelPendingDispatch] failed:", e);
  }
}
